module.exports = function() {
  return new Worker(__webpack_public_path__ + "5f12f5840f49e55ea7f2.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/web_workers/test.worker.js
// module id = 665
// module chunks = 0